import { render, staticRenderFns } from "./BaseConfirm.vue?vue&type=template&id=82524614&"
import script from "./BaseConfirm.vue?vue&type=script&lang=js&"
export * from "./BaseConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports